import React, { useState } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  useMediaQuery,
  LinearProgress,
} from '@mui/material';

import Sidebar from '../components/sidebars/Sidebar';
import TopNav from '../components/top_bars/TopNav';
import StatisticsCards from '../components/top_bars/StatisticsCard';

import { useNavigate } from 'react-router-dom';

const PhoneChecker = () => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [otherNames, setOtherNames] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

 

  const handleSubmit = async () => {
  if (phoneNumber.trim().length < 7) {
    alert('Please enter a valid phone number');
    return;
  }
  if (!firstName.trim()) {
    alert('Please enter your first name');
    return;
  }
  if (!otherNames.trim()) {
    alert('Please enter your other names');
    return;
  }
  if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
    alert('Please enter a valid email address');
    return;
  }

  const payload = {
    first_name: firstName.trim(),
    other_names: otherNames.trim(),
    email: email.trim(),
    phone: phoneNumber.trim(),
    password:phoneNumber.trim(),
    user_type:'hr_staff' 
  };

  setLoading(true);

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/initialise_staff.php`, {
     
      
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (response.ok && result.success) {
      alert('Staff initialized successfully. Proceed to login with email as username and phone as initial password');
      localStorage.setItem('phoneNumber', payload.phone);
      localStorage.setItem('firstName', payload.first_name);
      localStorage.setItem('otherNames', payload.other_names);
      localStorage.setItem('email_staff', payload.email);
      navigate('/dashboard');
    } else {
      const msg = result.message || 'Registration failed';
      alert(`Error: ${msg}`);
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Something went wrong. Please try again later.');
  } finally {
    setLoading(false);
  }
};

const handleReset = () => {
  setPhoneNumber('');
  setFirstName('');
  setOtherNames('');
  setEmail('');
  localStorage.clear();
};

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isMobile ? 0 : sidebarOpen ? 30 : 5,
          maxWidth: '1400px',
          mx: 'auto',
          width: '100%',
        }}
      >
        <TopNav
          onLogout={() => {
            localStorage.clear();
          }}
          onNotificationClick={() => alert('You have new notifications!')}
          toggleSidebar={toggleSidebar}
        />

        <Box sx={{ mt: 2 }}>
          <StatisticsCards />
        </Box>

        <Grid container spacing={3} sx={{ mt: 4 }}>
          <Grid item xs={12}>
            <Paper
              elevation={4}
              sx={{
                p: 3,
                borderRadius: 4,
                width: '100%',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
              }}
            >
              <Typography variant="h6" gutterBottom>
                Staff Initialization Information
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="First Name"
                    fullWidth
                    required
                    sx={{ minWidth: '550px' }}
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    disabled={loading}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Other Names"
                    fullWidth
                    required
                    sx={{ minWidth: '550px' }}
                    value={otherNames}
                    onChange={(e) => setOtherNames(e.target.value)}
                    disabled={loading}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Phone Number"
                    fullWidth
                    required
                    sx={{ minWidth: '550px' }}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    disabled={loading}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Email"
                    type="email"
                    fullWidth
                    required
                    sx={{ minWidth: '550px' }}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                  />
                </Grid>
              </Grid>

              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>

              
               <Button
  variant="contained"
  onClick={handleSubmit}
  disabled={loading}
  sx={{
    mt: 3,
    textTransform: 'none',
    fontWeight: 'bold',
    borderRadius: 2,
    backgroundColor: '#C84646', // primary oxblood tone
    '&:hover': {
      backgroundColor: '#b33c3c', // darker on hover
    },
  }}
>
  Submit
</Button>

                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleReset}
                  disabled={loading}
                >
                  Reset
                </Button>
              </Box>

              {loading && (
                <Box sx={{ mt: 3 }}>
                  <LinearProgress />
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Preparing your data...
                  </Typography>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PhoneChecker;
